module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "surveillance-personal-info"
  }, [_c('h2', [_vm._v("Resident Information")]), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 5
    }
  }, [_c('span', [_vm._v("First Name: ")])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 16
    }
  }, [_vm._v("\n        " + _vm._s(_vm.clientData.firstName) + "\n    ")])], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 5
    }
  }, [_c('span', [_vm._v("Middle Name: ")])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 16
    }
  }, [_vm._v("\n        " + _vm._s(_vm.clientData.middleName) + "\n    ")])], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 5
    }
  }, [_c('span', [_vm._v("Last Name: ")])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 16
    }
  }, [_vm._v("\n        " + _vm._s(_vm.clientData.lastName) + "\n    ")])], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 5
    }
  }, [_c('span', [_vm._v("Date of Birth: ")])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 16
    }
  }, [_vm._v("\n        " + _vm._s(_vm.clientData.date_of_birth) + "\n    ")])], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 5
    }
  }, [_c('span', [_vm._v("Staff: ")])]), _vm._v(" "), (_vm.isStaff()) ? _c('el-col', {
    attrs: {
      "span": 16
    }
  }, [_vm._v("\n        Yes\n    ")]) : _c('el-col', {
    attrs: {
      "span": 16
    }
  }, [_vm._v("\n        No\n    ")])], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 5
    }
  }, [_c('span', [_vm._v("Gender: ")])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 16
    }
  })], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 5
    }
  }, [_c('span', [_vm._v("Address 1: ")])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 16
    }
  })], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 5
    }
  }, [_c('span', [_vm._v("Address 2: ")])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 16
    }
  })], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('span', [_vm._v("City: ")])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_vm._v(" \n    ")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('span', [_vm._v("Prov/State: ")])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  })], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 5
    }
  }, [_c('span', [_vm._v("Postal Code: ")])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 16
    }
  })], 1), _vm._v(" "), _c('div', [_c('h2', {
    staticStyle: {
      "float": "left"
    }
  }, [_vm._v("Resident Notes")]), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "float": "right",
      "margin-top": "0.83em"
    },
    on: {
      "click": function($event) {
        _vm.addNewNote()
      }
    }
  }, [_vm._v("+ New")])], 1), _vm._v(" "), _c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.allNotes,
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "Date",
      "prop": "created",
      "width": "120"
    },
    scopedSlots: {
      default: function(scope) {
        return [_vm._v("\n          " + _vm._s(_vm._f("moment")(scope.row.created, 'DD-MM-YYYY')) + "\n        ")]
      }
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Content"
    },
    scopedSlots: {
      default: function(scope) {
        return [(scope.row.isNew) ? _c('div', [_c('el-input', {
          directives: [{
            name: "model",
            rawName: "v-model",
            value: (scope.row.content),
            expression: "scope.row.content"
          }],
          attrs: {
            "type": "textarea",
            "autosize": "",
            "placeholder": "Please input"
          },
          domProps: {
            "value": (scope.row.content)
          },
          on: {
            "input": function($event) {
              scope.row.content = $event
            }
          }
        })], 1) : _c('div', {
          staticClass: "case-note-content"
        }, [_vm._v(_vm._s(scope.row.content))])]
      }
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Action",
      "width": "150"
    },
    scopedSlots: {
      default: function(scope) {
        return [_c('el-button-group', [(scope.row.isNew) ? _c('el-button', {
          attrs: {
            "size": "small"
          },
          on: {
            "click": function($event) {
              _vm.saveAction(scope.$index, scope.row)
            }
          }
        }, [_vm._v("\n              Save\n            ")]) : _vm._e(), _vm._v(" "), (scope.row.isNew) ? _c('el-button', {
          attrs: {
            "size": "small"
          },
          on: {
            "click": function($event) {
              _vm.cancelAction(scope.$index, scope.row)
            }
          }
        }, [_vm._v("\n              Cancel\n            ")]) : _vm._e()], 1)]
      }
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-2bbbb414!./~/vue-loader/lib/selector.js?type=template&index=0!./~/eslint-loader!./src/components/SurveillancePersonalInfo.vue
// module id = 242
// module chunks = 2